import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  roomMakeStateRecoil,
  roomEntranceStateRecoil,
} from '../atom/ModalAtom';
import Header1 from '../component/Header1';
import RoomMake from '../modal/input/RoomMake';
import RoomEntrance from '../modal/input/RoomEntrance';
import { userIdState } from '../atom/TokenAtom';
import { RoomsDto, RoomPasswordDto } from '../model/room.dto';
import { tokenTriggerRecoil, accessTokenRecoil } from '../atom/UserAtom';
import { authAPI, roomAPI } from '../api/axiosIndex';
import { Icon } from '../component/Icon';

const DispatchList = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const navigate = useNavigate();

  const [accessToken, setAccessToken] = useRecoilState(accessTokenRecoil);

  const [roomMakeState, setRoomMakeState] = useRecoilState(roomMakeStateRecoil);
  const [roomEntranceState, setRoomEntranceState] = useRecoilState(
    roomEntranceStateRecoil,
  );

  const [rooms, setRooms] = useState<RoomsDto>();
  const [searchRooms, setSearchRooms] = useState<RoomsDto>();
  const [searchTitle, setSearchTitle] = useState('');
  const [searchLastTitle, setSearchLastTitle] = useState('');
  const [selectRoomId, setSelectRoomId] = useState<number>(0);

  const fetchRooms = async () => {
    try {
      const response = await roomAPI.getRooms();
      const sortedRooms = response
        ? [...response.data].sort((a, b) => {
            if (a.already === b.already) {
              return b.id - a.id;
            }
            return a.already ? -1 : 1;
          })
        : [];
      setRooms(sortedRooms);
    } catch (err: any) {
      console.error(err);
    }
  };

  const handleSearch = () => {
    const filtered = rooms?.filter((room) => room.title.includes(searchTitle));
    setSearchLastTitle(searchTitle);
    setSearchRooms(filtered);
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  return (
    <>
      <Header1 title="전체 목록" />
      <LS.MainCntLayout>
        <CS.SearchBox>
          <input
            type="text"
            placeholder="방 제목 입력"
            value={searchTitle}
            onChange={(e) => setSearchTitle(e.target.value)}
          />
          <button className="img-box" onClick={handleSearch}>
            <Icon name="SearchIcon" size="100%" color="#fff" />
          </button>
        </CS.SearchBox>
        {searchRooms && (
          <CS.SearchResultText>
            &quot;{searchLastTitle}&quot;에 대한 검색 결과 입니다.
          </CS.SearchResultText>
        )}
        {searchRooms && (
          <LS.RoomListBox>
            {searchRooms?.map((room) => (
              <CS.RoomList key={room.id}>
                <div className="text-box">
                  <div className="title-box">
                    <h1>{room.title}</h1>
                  </div>
                  {/* <div className="people-num-box">
                    <span>인원</span>
                    <span className="num">{room.personnel}</span>
                  </div> */}
                </div>
                {room.already && (
                  <button
                    type="button"
                    onClick={() => {
                      setSelectRoomId(room.id);
                      setRoomEntranceState(true);
                    }}
                    className="entry-btn history"
                  >
                    재입장
                  </button>
                )}
                {!room.already && (
                  <button
                    type="button"
                    onClick={() => {
                      setSelectRoomId(room.id);
                      setRoomEntranceState(true);
                    }}
                    className="entry-btn"
                  >
                    입장
                  </button>
                )}
              </CS.RoomList>
            ))}
          </LS.RoomListBox>
        )}
        {!searchRooms && (
          <LS.RoomListBox>
            {rooms?.map((room) => (
              <CS.RoomList key={room.id}>
                <div className="text-box">
                  <div className="title-box">
                    <h1>{room.title}</h1>
                  </div>
                  {/* <div className="people-num-box">
                    <span>인원</span>
                    <span className="num">{room.personnel}</span>
                  </div> */}
                </div>
                {room.already && (
                  <button
                    type="button"
                    onClick={() => {
                      setSelectRoomId(room.id);
                      setRoomEntranceState(true);
                    }}
                    className="entry-btn history"
                  >
                    재입장
                  </button>
                )}
                {!room.already && (
                  <button
                    type="button"
                    onClick={() => {
                      setSelectRoomId(room.id);
                      setRoomEntranceState(true);
                    }}
                    className="entry-btn"
                  >
                    입장
                  </button>
                )}
              </CS.RoomList>
            ))}
          </LS.RoomListBox>
        )}
      </LS.MainCntLayout>
      <AddBtn type="button" onClick={() => setRoomMakeState(true)}>
        <span className="img-box">
          <Icon name="PlusIcon" size="100%" color="#fff" />
        </span>
      </AddBtn>
      {roomMakeState && <RoomMake />}

      {roomEntranceState && selectRoomId !== null && (
        <RoomEntrance roomId={selectRoomId} />
      )}
    </>
  );
};

export default DispatchList;

export const AddBtn = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #d65757;
  position: fixed;
  z-index: 8;
  right: 12px;
  bottom: 112px;
  display: flex;
  align-items: center;
  justify-content: center;

  .img-box {
    width: 28px;
  }
`;
